export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/elearning_video_production.6588045.svg";